/**
 * StreamInputDTO entity class
 */

/**
 * StreamInputDTOFactory
 * returns StreamInputDTO entity class
 *
 * @class StreamInputDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamInputDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamInputDTOFactory
 */
/* @ngInject */
export default function StreamInputDTOFactory (Entity) {
  /* === StreamInputDTO class === */

  /**
   * StreamInputDTO model
   *
   * @class StreamInputDTO
   * @classdesc StreamInputDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamInputDTO entity fields
   * @return {models.StreamInputDTO} StreamInputDTO entity
   */
  function StreamInputDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamInputDTO.prototype = Object.create(Entity.prototype)
  StreamInputDTO.prototype.constructor = StreamInputDTO

  /* === StreamInputDTO instance methods & fields === */

  Object.assign(StreamInputDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamInputDTO#
     * @type {Object}
     */
    _fields: {
      externalId: String,
      type: String,
      Enum: String, /* SETRIX_INPUT_TYPES */
      url: String,
      urlSchema: String
    }
  })

  /* === StreamInputDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamInputDTO, Entity)
  StreamInputDTO._name = 'StreamInputDTO'
  StreamInputDTO.init()

  return StreamInputDTO
}
